import {CurrentUserRoleAndLogin} from "../types/auth.types";

export const defaultCurrentUserRoleAndLogin: CurrentUserRoleAndLogin = {
  displayRole: '',
  role: '',
  login: ''
}
